import React from "react";
import { arrayOf, bool, number, shape, string } from "prop-types";

import Advertise from "../AccountTools/Advertise";
import PropertyManager from "../AccountTools/PropertyManager";
import SignInRegister from "../AccountTools/SignInRegister";
import Search from "../Search";
import {
  ACCOUNT_TITLE,
  AGENT_TOOLS_TITLE,
  EXPERTS_TITLE,
  INDUSTRY_HUB_TITLE,
  MY_ACTIVITY_TITLE,
  RESOURCES_TITLE
} from "./constants";
import {
  ItemText,
  ListTitle,
  MenuList,
  MenuListItem,
  RootMenu
} from "./MultiLevelMenu";
import * as S from "./styled";
import {
  Account,
  AccountTrigger,
  AgentTools,
  Experts,
  IndustryHub,
  MyActivity,
  MyActivityAndFoldersMenu,
  RentBuySellMenu,
  Resources,
  SalesRentalsMenu
} from "./SubMenu";

const MobileWeb = props => {
  const isManagerOrAgentOrSmallLandlord =
    props.is_manager || props.is_agent_or_small_landlord;
  const hasExpertsMenu =
    isManagerOrAgentOrSmallLandlord && props.mobile_or_tablet && props.is_agent;

  return (
    <S.MobileWebWrapper>
      <RootMenu
        render={({ onMenuOpen }) => (
          <div id="mWebMenu">
            <S.SearchWrapper>
              <Search placeholder="Search" />
            </S.SearchWrapper>
            <MenuList>
              {hasExpertsMenu ? (
                <MenuListItem isFullSize>
                  <ItemText
                    isBig
                    isWithArrow
                    onClick={() => onMenuOpen(EXPERTS_TITLE)}
                  >
                    {EXPERTS_TITLE}
                  </ItemText>
                </MenuListItem>
              ) : null}
              {isManagerOrAgentOrSmallLandlord ? (
                <MenuListItem isFullSize>
                  <ItemText
                    isBig
                    isWithArrow
                    onClick={() => onMenuOpen(AGENT_TOOLS_TITLE)}
                  >
                    {AGENT_TOOLS_TITLE}
                  </ItemText>
                </MenuListItem>
              ) : null}
              {props.is_agent_or_small_landlord ? (
                <MenuListItem isFullSize>
                  <ItemText
                    isBig
                    isWithArrow
                    onClick={() => onMenuOpen(INDUSTRY_HUB_TITLE)}
                  >
                    {INDUSTRY_HUB_TITLE}
                  </ItemText>
                </MenuListItem>
              ) : null}
              {props.is_agent_or_small_landlord && !props.is_small_landlord ? (
                <MenuListItem isFullSize>
                  <Advertise {...props} />
                </MenuListItem>
              ) : null}
              {!isManagerOrAgentOrSmallLandlord &&
              props.has_universal_landlord_experience ? (
                <PropertyManager />
              ) : null}
              {isManagerOrAgentOrSmallLandlord ? (
                <MenuListItem isFullSize isTitle>
                  <ListTitle>Explore</ListTitle>
                </MenuListItem>
              ) : null}
              {props.has_seller_landing_page ? (
                <RentBuySellMenu />
              ) : (
                <SalesRentalsMenu />
              )}
              <MenuListItem isFullSize>
                <ItemText href="/buildings" isBig>
                  Buildings
                </ItemText>
              </MenuListItem>
              {!isManagerOrAgentOrSmallLandlord ? (
                <MenuListItem isFullSize>
                  <ItemText
                    isBig
                    isWithArrow
                    onClick={() => onMenuOpen(RESOURCES_TITLE)}
                  >
                    {RESOURCES_TITLE}
                  </ItemText>
                </MenuListItem>
              ) : null}
              {props.signed_in ? (
                <>
                  {!isManagerOrAgentOrSmallLandlord ? (
                    <MyActivityAndFoldersMenu
                      current_folder={props.current_folder}
                      folders={props.folders}
                      form_authenticity_token={props.form_authenticity_token}
                      is_lists={props.is_lists}
                      onClick={() => onMenuOpen(MY_ACTIVITY_TITLE)}
                    />
                  ) : null}
                  <AccountTrigger
                    current_user={props.current_user}
                    is_agent_or_small_landlord={
                      props.is_agent_or_small_landlord
                    }
                    is_manager={props.is_manager}
                    onClick={() => onMenuOpen(ACCOUNT_TITLE)}
                  />
                </>
              ) : (
                <MenuListItem isSignOut>
                  <SignInRegister />
                </MenuListItem>
              )}
            </MenuList>
          </div>
        )}
        subMenuArray={[
          ...(!isManagerOrAgentOrSmallLandlord
            ? [<Resources {...props} />]
            : []),
          ...(hasExpertsMenu ? [<Experts />] : []),
          ...(props.is_agent_or_small_landlord ? [<IndustryHub />] : []),
          ...(isManagerOrAgentOrSmallLandlord
            ? [<AgentTools {...props} />]
            : []),
          ...(!isManagerOrAgentOrSmallLandlord && props.is_lists
            ? [<MyActivity />]
            : []),
          ...(props.signed_in ? [<Account {...props} />] : [])
        ]}
      />
    </S.MobileWebWrapper>
  );
};

MobileWeb.propTypes = {
  mobile_or_tablet: bool,
  has_universal_landlord_experience: bool,
  is_agent: bool,
  is_agent_or_small_landlord: bool,
  is_small_landlord: bool,
  is_manager: bool,
  is_lists: bool,
  signed_in: bool,
  current_user: shape({
    email: string
  }),
  has_seller_landing_page: bool,
  form_authenticity_token: string,
  current_folder: shape({
    id: number
  }),
  folders: arrayOf(
    shape({
      folder: shape({
        id: number,
        name: string
      })
    })
  )
};

MobileWeb.defaultProps = {
  mobile_or_tablet: false,
  has_universal_landlord_experience: false,
  is_agent: false,
  is_agent_or_small_landlord: false,
  is_small_landlord: false,
  is_manager: false,
  is_lists: false,
  signed_in: false,
  current_user: null,
  has_seller_landing_page: false,
  form_authenticity_token: "",
  current_folder: undefined,
  folders: []
};

export default MobileWeb;
